import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

export default function MatingWarningsDialog({ open, warnings = [], onCancel, onConfirm }) {
    return <Dialog open={open} onClose={onCancel} fullWidth maxWidth="md" aria-labelledby="mating-warnings-title"
        PaperProps={{ sx: { height: 640, maxHeight: "calc(100dvh - 32px)", m: 2,
            width: "calc(100% - 32px)", display: "flex", flexDirection: "column", overflow: "hidden" } }}>
        <DialogTitle id="mating-warnings-title" sx={{ flexShrink: 0 }}>
            Προειδοποίηση ελέγχου συζεύξεων
            <Typography component="span" variant="body2" sx={{ display: "block", mt: 1 }}>
                {warnings.length} προειδοποιήσεις. Ελέγξτε τη λίστα πριν συνεχίσετε με την καταχώρηση.
            </Typography>
        </DialogTitle>
        <DialogContent dividers tabIndex={0} role="region" aria-label="Προειδοποιήσεις σύζευξης"
            sx={{ flex: "1 1 auto", minHeight: 0, overflowY: "auto", overscrollBehavior: "contain" }}>
            <Box component="ul" sx={{ m: 0, pl: 3 }}>
                {warnings.map((warning, index) => <Box component="li" key={index} sx={{ mb: 1.5 }}>{warning}</Box>)}
            </Box>
        </DialogContent>
        <DialogActions sx={{ flexShrink: 0, p: 2, gap: 1, flexWrap: "wrap", bgcolor: "background.paper" }}>
            <Button variant="outlined" color="secondary" onClick={onCancel} sx={{ minHeight: 44 }}>Ακύρωση</Button>
            <Button variant="contained" color="secondary" onClick={onConfirm} sx={{ minHeight: 44 }}>Συνέχεια και Υποβολή</Button>
        </DialogActions>
    </Dialog>;
}
